import * as React from 'react'
import classnames from 'classnames'
import * as ReactDOM from 'react-dom'

type ModalSize = 'sm' | 'md' | 'lg'

export interface Props {
  isOpen: boolean
  children: React.ReactNode
  /** size of modal; defaults to `lg` which is a fullscreen modal */
  size?: ModalSize
  onClose: () => void
  // normally the modal is positioned in the page, and will be affected
  // by scrolling the page. This makes it positioned `fixed` and it
  // will not be affected by scroll.
  positionFixed?: boolean
}

const Modal: React.FunctionComponent<Props> = ({
  isOpen,
  children,
  onClose,
  size = 'lg',
  positionFixed = false
}) => {
  const classList = ['modal-window', size]
  if (positionFixed) classList.push('fixed')
  const classes = classnames(...classList)

  return isOpen
    ? ReactDOM.createPortal(
        <div className="">
          <div className="modal-wrap">
            <div className="modal-overlay" />
            <div className={classes}>
              <span className="modal-close" onClick={onClose}>
                <svg className="svg-sprite">
                  <use xlinkHref="#remove" />
                </svg>
              </span>
              <div className="modal-content u-pad-02" role="document">
                {children}
              </div>
            </div>
          </div>
        </div>,
        document.body
      )
    : null
}

export default Modal
